export default "__VITE_ASSET__OnYbAUFc__"